import React, { useEffect, useState } from 'react'
import DataTable from 'datatables.net'; // eslint-disable-line 
import { useForm } from 'react-hook-form';
import { PropTypes } from 'prop-types'

import { Container } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import { Card, Col, Row } from 'react-bootstrap'
import { NoData } from '../../components/common/NoData';
import { ButtonView } from '../../components/common/ButtonView';

import { Loading } from '../../components/common/Loading';
import ErrorMessage from '../../components/common/ErrorMessage';
import { PageHeaderStandar } from '../../components/common/PageHeaderStandar';
import { useisLoading } from '../../hook/useisLoading';
import helperDataTable from '../../components/helpers/helperDataTable';

import auth from '../../components/common/Auth';
import { getUsers } from '../../components/selector/getUsers';
import { UsersAPI } from '../../components/apis';

// TODO-LIST:
// Rever la obtención del "context" de Redux en el helperDataTable.js

export const Users = (props, context) => {

    const { user, token } = useSelector(state => state.user);

    // Get "accounts" loaded from store in ApplicationContext component in order to fill the "SelectCombobox" inputs.
    const { accounts } = useSelector(state => state.accounts);
  
    // Variable to show/hide "spinner" while loading page.
    const { isLoading, hideSpinner } = useisLoading(true); // Start showing spinner till load users service
  
    // Stander useForm of react-hook-form Library
    const { getValues, setValue, reset, formState, setError } = useForm({
        defaultValues: {
            // User default attribute for create new entity
            
            usersList: null, // for load user list from API request (also implement useWatch function)
            // Axuliar varialbes to los acctounts and roles values from services.
            accounts: null,
            roles: null,
    
            // backendError is used to set back-end-error message when service has fail (to show to the user)
            backendError: null,
            // onSubmitOk is used to control if onSubmit acction was success.
            onSubmitOk: null,
        }
    });
  
    
    const [apiUser, setApiUser] = useState(null);

    // Load API Object
    useEffect(() => {

        if (token) {
            setApiUser(new UsersAPI(token));
        }

    }, [token])
    
    
    // Use effect to load user table data from API request.
    useEffect( () => {
           
        if (apiUser){
            apiUser.getAll().then(  (result) => {
                // Setting users list in react-hook-form objet named "userList"
                setValue("usersList", result);
                
                hideSpinner();
                
            }).catch(err => {
                
                console.log("Error getting users list from Users.js: " + err);
                setError("backendError", "There is no users retrived.");

            }).finally(function () {
                hideSpinner();
                helperDataTable("#usersListTable", 5, context);
            });

        }

    }, [apiUser]);


    // We show the spinner while the page is loading.
    if (isLoading || !user || !accounts) {

        return <Loading/>

    } else {

        return  (
                <Container id="usersPage" fluid className="main-content-container px-4">
                    
                    {/* If "backendError" has value, it shows to the user */}
                    <ErrorMessage message={getValues().backendError}/>
        
                    {/* Page header has Title and Subtite of the page */}
                    <PageHeaderStandar title={context.t('Users')} subtitle={context.t('List')} userRoleId={user.roles[0].id} routeTo='/users/new' materialUIText='person_add' />
                    <br/>
                    
                    {
                        (!!getValues().usersList && getValues().usersList.length > 0 )? (
                            <table id='usersListTable' className='snx-table-list'>
                                <tbody>
                                { getValues().usersList.map( user => {
                                    return (
                                        <tr key={user.id}>
                                            <td>
                                                <Card className="snx-card-list">  
                                                    <Card.Header className='snx-card-list-header'>
                                                        <Row>
                                                            <Col>
                                                                <i className="material-icons snx-icon md-18">badge</i>
                                                                <span> {user.given_name} {user.family_name}</span>
                                                            </Col>
                                                            <Col>
                                                                <i className="material-icons snx-icon md-18">business</i>
                                                                <span> { accounts.find((account) => account.id === user.account_id).name}</span>
                                                            </Col>
                                                            <Col>
                                                                <ButtonView to={'/users/'+user.id+"/account/"+user.account_id} buttonClass="float-right" />
                                                            </Col>
                                                        </Row>
                                                    </Card.Header>
                                                    <Card.Body className='snx-card-list-body'>
                                                        <div >
                                                        <Row>
                                                            <Col>
                                                                <i className="material-icons snx-icon">account_circle</i> {user.user_name}  ({user.roles[0].name})
                                                                <br/>
                                                                <i className="material-icons snx-icon">email</i> {user.email}
                                                                <br/>
                                                                <i className="material-icons snx-icon">local_phone</i> {(user.phone_number !== "")?user.phone_number:context.t("Not available")}
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col className="snx-date">
                                                                <small className="pull-right"> <i className="material-icons">access_time</i> {user.created_at}</small>
                                                            </Col>
                                                        </Row>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </td>
                                        </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                            )
                        :
                            (
                                <NoData/>
                            )
                    }
                    <br/>
                    <br/> 
                </Container>   
              )
    }
}



Users.contextTypes = {
    t: PropTypes.func
}
  
export default Users;